import React, { useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { isMobileSelector } from "datamodel/Device/selectors";
import DownloadAppBanner from "components/download-app-banner";

import {
  Root,
  Header,
  GhostOffset,
  Navigation,
  NavigationList,
} from "./styled-components";

export const TopBarBase = ({
  children,
  dataQa = "top-bar",
  withNavigationWrapper = true,
}) => {
  const isMobile = useSelector(isMobileSelector);
  const [bannerHeight, setBannerHeight] = useState(0);

  const handleBannerChange = (height) => {
    setBannerHeight(height);
  };

  return (
    <>
      <Root data-qa={dataQa} id="topbar" isFixed={true} offset={0}>
        {isMobile && <DownloadAppBanner onLayoutChange={handleBannerChange} />}
        <Header>
          {withNavigationWrapper ? (
            <Navigation>
              <NavigationList>{children}</NavigationList>
            </Navigation>
          ) : (
            children
          )}
        </Header>
      </Root>
      <GhostOffset isFixed={bannerHeight !== 0} offset={bannerHeight} />
    </>
  );
};

TopBarBase.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.element]).isRequired,
  dataQa: PropTypes.string,
  withNavigationWrapper: PropTypes.bool,
};

TopBarBase.defaultProps = {
  dataQa: "top-bar",
  isMobile: false,
  withNavigationWrapper: true,
};

export default TopBarBase;
